import React, { createContext, useReducer, useContext, useEffect } from 'react';
import { fetchUserAttributes } from 'aws-amplify/auth';

const UserContext = createContext();

const initialState = {
  userAttributes: null,
  loading: true,
  error: false,
};

const userReducer = (state, action) => {
  switch (action.type) {
    case 'SET_USER_ATTRIBUTES':
      return { ...state, userAttributes: action.payload, loading: false };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, initialState);

  useEffect(() => {
    async function fetchUserData() {
      try {
        const attributes = await fetchUserAttributes();
        dispatch({ type: 'SET_USER_ATTRIBUTES', payload: attributes });
      } catch (error) {
        console.error("Error fetching user attributes:", error);
        dispatch({ type: 'SET_ERROR', payload: true });
      }
    }

    fetchUserData();
  }, []);

  return (
    <UserContext.Provider value={{ state, dispatch }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
